// Einstieg in den Spielmodus von außen: ab einer Stellung gegen einen Bot weiterspielen oder eine
// Partie der Bibliothek raten („Spiel wie …“). Links: #/spielen?ab=<FEN> und #/spielen?raten=<Id>&seite=w&zug=<n>.
import { api } from './api';
import { GuessGame, type Side } from './guessgame';
import { t } from './i18n';
import type { PlayCtrl } from './playctrl';
import { PlayGame } from './playgame';

export const continueHref = (fen: string) => `#/spielen?ab=${encodeURIComponent(fen)}`;
export const guessHref = (id: number, side: Side, ply: number) => `#/spielen?raten=${id}&seite=${side === 'white' ? 'w' : 'b'}&zug=${ply}`;

/** „Kasparov,G“ → „Kasparov“, „Carlsen, Magnus“ → „Carlsen“; ohne Komma der ganze Name */
export function shortName(name: string | null | undefined): string {
  const n = (name ?? '').trim();
  return (n.includes(',') ? n.split(',')[0].trim() : n) || '?';
}

/** Beschriftung einer eigenen Startstellung, aus der FEN */
export function startLabel(fen: string): string {
  const [, turn, , , , full] = fen.split(' ');
  return t('Zug {n}, {s} am Zug', { n: full ?? '1', s: turn === 'b' ? t('Schwarz') : t('Weiß') });
}

/** Startstellung für die nächste Partie setzen; die eigene Farbe ist die Seite am Zug */
export function continueFrom(c: PlayCtrl, fen: string) {
  c.game++; // laufende Antwort des Gegners verwerfen
  c.guess = null;
  c.start = { fen, label: startLabel(fen) };
  c.side = fen.split(' ')[1] === 'b' ? 'black' : 'white';
  // Stellung schon vor „Neue Partie“ zeigen
  Object.assign(c, { board: new PlayGame(fen), started: false, result: null, outcome: null, train: null, error: '' });
  c.redraw();
}

/** Link aus der Adresse auswerten; true, wenn einer da war */
export function openPlayLink(c: PlayCtrl, query: string): boolean {
  const q = new URLSearchParams(query);
  const ab = q.get('ab'), id = Number(q.get('raten'));
  if (ab) continueFrom(c, ab);
  else if (id > 0) void openGuess(c, id, q.get('seite') === 'b' ? 'black' : 'white', Number(q.get('zug')) || 0);
  return !!ab || id > 0;
}

async function openGuess(c: PlayCtrl, id: number, side: Side, ply: number) {
  c.error = '';
  try {
    const d = await api.game(id);
    if (d.plies.length < 2) throw new Error(t('Die Partie hat keine Züge.'));
    const meta = { id, white: d.game.white ?? '?', black: d.game.black ?? '?' };
    c.game++;
    c.guess = new GuessGame(meta, d.plies, side, ply, c.redraw);
    c.started = false;
  } catch (e) {
    c.error = (e as Error).message;
  }
  c.redraw();
}
